<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">备件编号：</span>
        <el-input v-model="spareNum" :size="size" clearable placeholder="请输入备件编号"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">备件名称：</span>
        <el-input v-model="spareName" :size="size" clearable placeholder="请输入备件名称"></el-input>
      </div>
      <div class="header_item">
      <el-button icon="el-icon-search" @click="searchSporepartList(true)">查询</el-button>
      <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      <el-button icon="el-icon-upload2" @click="exportExcel()">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="sparepartList"
        height="100%" >
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="spareNum" label="备件编号" align="center"></el-table-column>
        <el-table-column prop="spareName" label="备件名称" align="center"></el-table-column>
        <el-table-column prop="model" label="规格型号" align="center"></el-table-column>
        <el-table-column prop="spareTypeName" label="类型" align="center"></el-table-column>
        <el-table-column label="备件状态" align="center">
          <template #default="{ row }">
            <div>
              {{spareStatusData[row.spareStatus]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spareAdminName" label="负责人" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增备品备件 修改备品备件 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增备品备件' : '修改备品备件信息'"
      :visible.sync="asyncSparepart"
      width="35%">
      <el-form ref="form" :model="formSparepart" :rules="rulesSparepart" label-width="auto" class="rule_form">
        <el-form-item label="备件编号：" prop="spareNum">
          <el-input v-model="formSparepart.spareNum" :size="size" clearable placeholder="请输入备件编号"></el-input>
        </el-form-item>
        <el-form-item label="备件名称：" prop="spareName">
          <el-input v-model="formSparepart.spareName" :size="size" clearable placeholder="请输入备件名称"></el-input>
        </el-form-item>
        <el-form-item label="规格型号：" prop="model">
          <el-input v-model="formSparepart.model" :size="size" clearable placeholder="请输入规格型号"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="spareType">
          <el-select v-model="formSparepart.spareType" :size="size" clearable placeholder="请选择类型">
            <el-option 
              v-for="item in sportpartTypeData"
              :key="item.dictId"
              :label="item.dictName" 
              :value="item.dictId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备件状态：" prop="spareStatus">
          <el-select v-model="formSparepart.spareStatus" :size="size" clearable placeholder="请选择备件状态">
            <el-option label="使用中" :value="1"></el-option>
            <el-option label="未使用" :value="2"></el-option>
            <el-option label="作废" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人：" prop="spareAdmin">
          <el-select v-model="formSparepart.spareAdmin" :size="size" clearable placeholder="请选择负责人">
            <el-option 
              v-for="item in staffData"
              :key="item.userId"
              :label="item.realName" 
              :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="formSparepart.remark" 
            :size="size" 
            clearable 
            placeholder="请输入备注"
            type="textarea"
            maxlength="200"
            rows="8"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncSparepart = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from "../../pinia/index";
import { changeSize, throttle, downLoadFile } from '../../plugins/public';
  export default {
    data() {
      return {
        spareNum: '',
        spareName: '',
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 1,
        loading: true,
        sparepartList: [], // 备品备件信息列表
        asyncTitle: true, // true 添加信息  false 修改信息
        asyncSparepart: false, // 弹出框
        formSparepart: {}, // 表单信息
        rulesSparepart: {
          spareNum: [{
            required: true, 
            message:'请输入备件编号', 
            trigger: 'blur'
          }],
          spareName: [{
            required: true, 
            message:'请输入备件名称', 
            trigger: 'blur'
          }],
          model: [{
            required: true, 
            message:'请输入规格型号', 
            trigger: 'blur'
          }],
          spareType: [{
            required: true, 
            message:'请选择类型', 
            trigger: ['blur', 'change']
          }],
          spareStatus: [{
            required: true, 
            message:'请选择备件状态', 
            trigger: ['blur', 'change']
          }],
          spareAdmin:[{
            required: true, 
            message:'请选择负责人', 
            trigger: ['blur', 'change']
          }]
        }, // 校验规则
        sportpartTypeData: [], // 备件类型
        staffData: [], // 负责人
        spareStatusData: {
          1: '使用中',
          2: '未使用',
          3: '作废'
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchSporepartList(true );
    },
    methods: {
      // 获取备件类型信息
      async getSporepartTypeData() {
        const { data } = await this.$api.Dictionary.searchDictionary({
          dictType: 8,
          pageNum: 1,
          pageSize: 10000
        });
        this.sportpartTypeData = data.list;
      },
      // 获取全部人员信息
      async getAllStaffData() {
        const { data } = await this.$api.Personnerl.GETSTAFFALLDATA();
        this.staffData = data;
      },
      // 查询备品备件信息
      searchSporepartList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.sparepartList = [];
        this.$api.Materials.SEARCHSPAREPARTLIST({
          spareNum: this.spareNum,
          spareName: this.spareName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.sparepartList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncSparepart = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncSparepart = true;
        this.$set(this.formSparepart, 'spareId', row.spareId);
        this.$set(this.formSparepart, 'spareNum', row.spareNum);
        this.$set(this.formSparepart, 'spareName', row.spareName);
        this.$set(this.formSparepart, 'model', row.model);
        this.$set(this.formSparepart, 'spareType', row.spareType);
        this.$set(this.formSparepart, 'spareStatus', row.spareStatus);
        this.$set(this.formSparepart, 'spareAdmin', row.spareAdmin);
        this.$set(this.formSparepart, 'remark', row.remark);
      },
      // 导出Excel
      exportExcel() {
        this.$api.System.GETEXPORTTOKENDATA({
          spareNum: this.spareNum,
          spareName: this.spareName,
        }).then((res) => {
          if(res.success) {
            downLoadFile(res.data, '/htapi/materials/spare/export');
          }
        })
      },
      // 删除备品备件信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该备件信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
        console.log(row);
         this.$api.Materials.DELETESPAREPARTINFO({spareId: row.spareId})
        .then(res => {
          if(res.success) {
            this.searchSporepartList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formSparepart);
            this.$api.Materials.INSERTSPAREPARTINFO(params).then((res) => {
              if(res.success) {
                this.asyncSparepart = false;
                this.searchSporepartList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formSparepart);
            this.$api.Materials.UPDATESPAREPARTINFO(params).then((res) => {
              if(res.success) {
                this.asyncSparepart = false;
                this.searchSporepartList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchSporepartList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchSporepartList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncSparepart(bol) {
        if(bol) {
          this.getSporepartTypeData();
          this.getAllStaffData();
        }else {
          this.formSparepart = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>